export var TypeConversationData;
(function (TypeConversationData) {
    TypeConversationData["PUBLIC"] = "public";
    TypeConversationData["PRIVATE"] = "private";
})(TypeConversationData || (TypeConversationData = {}));
//# sourceMappingURL=type-conversation-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/message/type-conversation-data.js
// module id = 454
// module chunks = 14